module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARtJREFUeNpi/P//PwMtAQuIYGRkLIHybwPxRihbAohjKDD7EtDxu1igHB4ozYWkgBlJnBzACSKYaBg64LBnBMUBMIjkoILfgfg1lM0GDSZywReg2e8YaBnJILOZGGgMYJEcDqWfAPFRKFsIiF0pMPsuEJ+BWaCJZOFRpBSlSYEFv0AWoAcRIxVDhxE5iA5B6VdICj4hiZMDnsJjelikImMo/R6I70HZ3ECsQYHZoAz7CGaBL1JhB7NAEEmcHHARZAETtvKDmmURC1IGQ09FP5HEyQFvhlcqEkLK3l+Q5PgoMBsUxF9hFmRB6RtAvAbKFgPiJAosOAfE21jQfMKKpIAJSZwcwIps8Hco/QNJwV8kcXLAD3iVSUsAEGAAoJhRCWzYXWMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/vdt.png
// module id = 208
// module chunks = 1